<template>
  <div :class="$style.card">
    <div v-if="this.$store.state.admin">
      <div @backToCard="closeBuyCard">
        <div :class="$style.wrapper">
          <div :class="$style.photo">
            <img
              :src="
                object.photo_urls.length > 0
                  ? (object.thumb_urls && object.thumb_urls[0]) || object.photo_urls[0]
                  : '../assets/img/placeholder.png'
              "
              loading="lazy"
              alt=""
            />
          </div>
          <div :class="$style.title">
            <p :class="$style.tag">ID {{ object.id }}</p>
            <p :class="$style.name">{{ object.header }}</p>
          </div>
        </div>
      </div>
    </div>
    <div v-else @click="writeOpenCard(object)">
      <div @backToCard="closeBuyCard">
        <div :class="$style.wrapper">
          <div :class="$style.photo">
            <img
              :src="
                object.photo_urls.length > 0
                  ? (object.thumb_urls && object.thumb_urls[0]) || object.photo_urls[0]
                  : '../assets/img/placeholder.png'
              "
              loading="lazy"
              alt=""
            />
          </div>
          <div :class="$style.title">
            <p :class="$style.tag">{{ object.category }}</p>
            <p :class="$style.name">{{ object.header }}</p>
            <p v-if="object.price_from" :class="$style.price">
              {{ object.has_layouts ? 'от ' : ''
              }}{{ new Intl.NumberFormat('ru-RU').format(object.price_from) }} ₽
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    object: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      openCard: false,
    };
  },
  methods: {
    closeBuyCard() {
      this.openCard = false;
    },
    writeOpenCard(object) {
      this.$store.commit('writeOpenCard', object);

      if (this.$store.state.object) {
        this.$router.push({ path: `/opencard/${object.id}`, params: { objectId: object.id } });
      }
    },
  },
};
</script>

<style lang="scss" module>
@keyframes show {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 100%;
  }
}

.card {
  background-color: $bg-light;
  border-radius: 16px;
}

.wrapper {
  width: 100%;
  border: none;
  border-radius: 16px;
  overflow: hidden;
  transition: all 0.2s ease;
  opacity: 100%;
  animation-name: show;
  animation-duration: 1s;

  &:hover {
    transition: all 0.2s ease;
    opacity: 0.5;
  }
}

.photo {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 120px;
  img {
    margin: 0;
    width: 100%;
    object-fit: cover;
    height: 100%;
  }
}

.title {
  padding: 12px;
}

.tag {
  font-weight: 600;
  font-size: 9px;
  line-height: 14px;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: $primary-light;
  margin-bottom: 6px;
}

.name {
  font-weight: 600;
  font-size: 12px;
  line-height: 16px;
  color: $white;
}

.price {
  margin-top: 6px;
  font-weight: 600;
  font-size: 12px;
  color: $primary-light;
}
</style>
